<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
<div *ngIf="similarcat && similarcat.length>0">
  
  <div *ngIf="id !== 1 && id !==2 && id !==3">
    <ion-card *ngFor="let data of similarcat">
      <ion-row  >
  
                  <ion-col col-6  style="   background-color: #fff;">
                    <div style="margin-left: 10%;height:100px; cursor:pointer; margin:2px;  "
                    (click)="goToSimilarProduct(data.id, data.name);">
              <img src="https://passport.petcart.in/images/prodimgs/{{data.image}}" style="height: 90px; width: auto; margin-left: 20px;">
                    </div>
                  </ion-col>
                  <ion-col col-6 >
                  <div (click)="goToSimilarProduct(data.id, data.name);">
                      <p style="margin-right: 40%;font-size: 1.7rem;margin-top: 20%;color: #9b7544; text-transform: capitalize; overflow-wrap:break-word">
                          {{data.name}}
                       </p>
                </div>
                  </ion-col>
                </ion-row>
              </ion-card>
            </div>
  
            <div *ngIf="id == 1">
               <img  (click)="goToSimilarProduct(5, 'Food');" class="dogcatg" src="https://petcart.in/mobassets/dogcatg1.jpg">
                <img  (click)="goToSimilarProduct(6, 'Treats');" class="dogcatg" src="https://petcart.in/mobassets/dogcatg2.jpg">
                 <img  (click)="goToSimilarProduct(7, 'Supplies');" class="dogcatg" src="https://petcart.in/mobassets/dogcatg3.jpg">
  
  
  
            </div>
            <div *ngIf="id == 2">
               <img  (click)="goToSimilarProduct(8, 'Food');" class="catcatg" src="https://petcart.in/mobassets/catcatg1.jpg">
                <img  (click)="goToSimilarProduct(9, 'Treats');" class="catcatg" src="https://petcart.in/mobassets/catcatg2.jpg">
                 <img  (click)="goToSimilarProduct(11, 'Supplies');" class="catcatg" src="https://petcart.in/mobassets/catcatg3.jpg">
                 <img  (click)="goToSimilarProduct(10, 'Litter and Accessories');" class="catcatg" src="https://petcart.in/mobassets/catcatg4.jpg">
  
  
  
            </div>
  
            <div *ngIf="id == 3">
               <img  (click)="goToSimilarProduct(12, 'Food and Treats');" class="dogcatg" src="https://petcart.in/mobassets/birdcatg1.jpg">
                <img  (click)="goToSimilarProduct(13, 'Supplies');" class="dogcatg" src="https://petcart.in/mobassets/birdcatg2.jpg">
                 <img  (click)="goToSimilarProduct(14, 'Supplements');" class="dogcatg" src="https://petcart.in/mobassets/birdcatg3.jpg">
  
  
  
            </div>
  
              </div>